import { InjectionToken } from '@angular/core';
import { UserManagementConstants } from './constants';

export const USER_MANAGEMENT_CONSTANTS = new InjectionToken<UserManagementConstants>(
  'Constants provided by User Management library'
);